import { observer } from 'mobx-react-lite'
import { useEffect, useRef } from 'react'

import { store } from '../stores/store'
import { useRunState } from './provider/useRunState'

export const SettingsPauseBridge = observer(function SettingsPauseBridge() {
    const runState = useRunState()
    const resumePhaseRef = useRef<typeof runState.phase | null>(null)
    const appFlowPhase = store.appFlowPhase
    const settingsOpen = store.settingsOpen

    useEffect(() => {
        if (!settingsOpen) {
            if (resumePhaseRef.current && runState.phase === 'paused') {
                runState.setPhase(resumePhaseRef.current)
            }

            resumePhaseRef.current = null
            return
        }

        if (appFlowPhase !== 'run') return
        if (runState.phase !== 'running' && runState.phase !== 'levelTransition') return

        resumePhaseRef.current = runState.phase
        runState.pause()
    }, [appFlowPhase, runState, runState.phase, settingsOpen])

    return null
})
